import type { AabAnalyticsDataAbTest } from '@shared/utils/AabAnalytics';

export type AbTestTemplate = Omit<AabAnalyticsDataAbTest, 'ab_test_variant'>;

export enum AbTestNames {
  CtaAppointmentLoondienst = 'CtaAppointmentLoondienst'
}

export enum AbTestsIds {
  CtaAppointmentLoondienst = 1
}

export const AB_TEST_TEMPLATES: Record<string, AbTestTemplate> = {
  [AbTestNames.CtaAppointmentLoondienst]: {
    ab_test_id: AbTestsIds.CtaAppointmentLoondienst,
    ab_test_name: 'CTA appointment loondienst',
    ab_test_platform: 'custom'
  }
};
